var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main"},_vm._l((_vm.listData),function(itemSt,indexSt){return _c('div',{key:indexSt,staticClass:"group-st"},[_c('div',{staticClass:"group-left"},[_c('CardItem',{attrs:{"data":itemSt,"isSplit":false,"idx":indexSt}})],1),_c('div',{staticClass:"group-right"},[_c('CardItem',{attrs:{"data":itemSt,"idx":indexSt}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }